import { defineCopy } from "@tami/core/intl";

import { TASKS_SCRIPT_COPY_EN_US } from "./en-us/tasks-script.copy";
import { TASKS_SCRIPT_COPY_ES_ES } from "./es-es/tasks-script.copy";

export const TASKS_SCRIPT_COPY_PT_BR = {
  tasksIntro: {
    narrative:
      "Central de Conteúdo: acesse tudo que já foi planejado e encontre qualquer publicação do histórico.",
  },
  tasksGrid: {
    narrative:
      "Filtre por data, status, mês ou campanha — cada card reúne plataforma, formato e prazo.",
    callout:
      "Todos os conteúdos planejados num só lugar, com status e campanha visíveis.",
  },
  tasksModalOpen: {
    narrative:
      "Crie um planejamento novo em segundos — tema, rede, formato e prazos num fluxo guiado.",
    callout:
      "Modal de cadastro: planeje conteúdo sem sair da Central de Conteúdo.",
  },
  tasksModalTitle: {
    narrative:
      "Comece pelo tema: série, collab, review ou qualquer ideia que você quer transformar em conteúdo.",
    callout:
      "Defina o assunto do conteúdo — o ponto de partida de todo planejamento.",
  },
  tasksModalCampaign: {
    narrative:
      "Publi e orgânico no mesmo fluxo: vincule a uma campanha ativa quando fizer sentido.",
    callout:
      "Conecte o conteúdo a uma campanha e mantenha entregáveis organizados.",
  },
  tasksModalPlatform: {
    narrative:
      "Escolha a rede certa e a Tãmi já prepara os formatos disponíveis para aquela plataforma.",
    callout:
      "Instagram, TikTok, YouTube e mais — escolha onde esse conteúdo vai ao ar.",
  },
  tasksModalFormat: {
    narrative:
      "Reels, stories, feed ou vídeo: o formato entra no plano desde o primeiro passo.",
    callout:
      "Selecione o tipo de conteúdo e evite retrabalho na hora de produzir.",
  },
  tasksModalDates: {
    narrative:
      "Separe data de produção e de publicação — gravação e postagem no prazo certo.",
    callout:
      "Quando produzir e quando postar — dois prazos, zero confusão na agenda.",
  },
  tasksRoteiroOpen: {
    narrative:
      "Cada item tem um roteiro dentro dele. Abrir é um clique, e o texto já está lá.",
    callout:
      "Central de conteúdo / a tarefa — o roteiro mora dentro dela.",
  },
  tasksRoteiroToolbar: {
    narrative:
      "Formatação de verdade e auto-save: não existe botão de salvar para esquecer.",
    callout:
      "Comentários da marca ficam no próprio roteiro, na linha certa.",
  },
  tasksRoteiroSheet: {
    narrative:
      "Gancho, desenvolvimento e fechamento com o tempo de cada parte — pronto para gravar.",
    callout:
      "O roteiro que você grava, não um bloco de notas solto.",
  },
  tasksRoteiroImage: {
    narrative:
      "Referência entra no meio do texto: a imagem combina o enquadramento antes de gravar.",
    callout:
      "Imagem no meio do roteiro, com legenda — texto e referência juntos.",
  },
  tasksRoteiroEnd: {
    narrative:
      "E o roteiro segue até o fechamento, com o que a marca pediu já anotado.",
    callout:
      "Rola até o fim: cupom, chamada e a ressalva da marca.",
  },
  tasksOutro: {
    narrative:
      "Da ideia ao roteiro pronto, no mesmo lugar em que a entrega é acompanhada.",
  },
} as const;

export const TASKS_SCRIPT_COPY = defineCopy(TASKS_SCRIPT_COPY_PT_BR, {
  "en-US": TASKS_SCRIPT_COPY_EN_US,
  "es-ES": TASKS_SCRIPT_COPY_ES_ES,
});
